import { Card, Spin } from "antd";
import Title from "antd/lib/skeleton/Title";
import React, { useEffect, useState } from "react";
import { Event } from "./Event";

import * as FirestoreService from "../../firebase";

export const EventsListCard = () => {
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);

  let data;
  useEffect(() => {
    setLoading(true);
    const unsubscribe = FirestoreService.streamEvents({
      next: (querySnapshot) => {
        const eventsList = querySnapshot.docs.map((docSnapshot) => {
          data = docSnapshot.data();
          data.id = docSnapshot.id;
          return data;
        });
        setEvents(eventsList);
        setLoading(false);
      },
      error: () => console.log("post-get-fail"),
    });
    return unsubscribe;
  }, []);
  return (
    <Card
      style={{
        borderRadius: 10,
        marginBottom: 25,
        boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
      }}
      title="Upcoming Events"
    >
      <Spin size="medium" spinning={loading} delay={100}>
        {events.map((event) => (
          <Event event={event} key={event.id} />
        ))}
        {!loading &&
          events.length === 0 &&
          "There are no scheduled events at this time."}
      </Spin>
    </Card>
  );
};
